module.exports = {"371202001":"凤城街道","371202002":"张家洼街道","371202003":"高庄街道","371202004":"鹏泉街道","371202100":"口镇","371202101":"羊里镇","371202102":"方下镇","371202103":"牛泉镇","371202105":"苗山镇","371202106":"雪野镇","371202107":"大王庄镇","371202108":"寨里镇","371202109":"杨庄镇","371202110":"茶业口镇","371202111":"和庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371202.json
// module id = 1573
// module chunks = 0